import React from 'react';

import Button from '~/components/core/Atomic/Buttons/Button';

interface UnexecuteButtonProps {
  onUnexecute: () => void;
}

export const InvoiceUnexecuteButton: React.FC<UnexecuteButtonProps> = ({ onUnexecute }) => {
  return (
    <Button
      variant="contained"
      classes={{
        root: 'ml-8 bg-gray-700 text-gray-700 [&&]:bg-gray-700/10 leading-none',
      }}
      onClick={onUnexecute}
    >
      Reopen
    </Button>
  );
};
